import apiClient from './apiClient'


const updateGuidelines = (chainId, guidelines) => {
  return apiClient.put(`/Chain/${chainId}/Guidelines`, {
    id: chainId,
    guidelines: guidelines
  })
}

export default {
  updateGuidelines
}
